module.exports = __webpack_public_path__ + "static/media/ale.e5bbf8dd.jpeg";